import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `0 ${theme.spacing(3)} ${theme.spacing(3)}`};
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li``;
